import { MeetingsMap, MeetingsState } from '../types';
import { AppState } from '../../rootReducer';

export const getState = (state: AppState): MeetingsState => state.meetingsReducer;

export const getMeetingsList = (state: AppState): MeetingsMap => state.meetingsReducer.meetings;

export const isLoading = (state: AppState): boolean => state.meetingsReducer.isLoading;

export const getError = (state: AppState): string => state.meetingsReducer.error || '';
